// From backend Devise.password_length.min (fallback matches Devise default)
export const MIN_PASSWORD_LENGTH = window.__MIN_PASSWORD_LENGTH__ || 6;
